import { Chip, Icon, Icons } from "@ir/ui"
import { IDeductionChip } from "./IDeductionChips"

interface DeductionChipProps extends Pick<IDeductionChip, "size" | "iconSize" | "style" | "className" | "shape"> {
    label?: string;
    icon?: Icons;
    ariaLabel?: string;
}

export const DeductionChip = ({ icon, label, shape = "square", ariaLabel, size, iconSize, style, className }: DeductionChipProps) => {
    return (
        <Chip
            variant="outline"
            shape={shape}
            icon={icon ? <Icon name={icon} aria-label={label} size={iconSize ?? size} /> : undefined}
            size={size}
            iconPosition={label && label.length > 0 && icon ? "left" : undefined}
            className={className}
            label={label}
            aria-label={ariaLabel ?? label}
            style={style}
        />
    )
}


